import { render, staticRenderFns } from "./HomeBlockBattle.vue?vue&type=template&id=7072ada2&name=home-block-battle&"
import script from "./HomeBlockBattle.vue?vue&type=script&lang=js&"
export * from "./HomeBlockBattle.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlockBattle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports